import { put, takeEvery } from "redux-saga/effects"
import { nextIndex, PUSH_PRESENT_HISTORY, TemplateOrAlternativeTemplateType, UndoRedoHistory } from "../undoRedoReducers";
import store from "store";
import { selectFormValues, updateInputValueProps } from "app/reducers/form";
import { Action } from "app/types/app-types"
import { isDifferentTemplateform } from "shape-edit/forms/helpers";
import { INIT_FORM, UPDATE_VALUE } from "products/types";

export const DO_NOT_SAVE_HISTORY = 'do-not-save-history';

export function* handleTemplateFormChanged(action: Action<updateInputValueProps>) {
    const payload = action.payload
    if (!payload || !payload.form || !['templateForm', 'altTemplateForm'].includes(payload.form)) {
        return
    }

    const currentState = store.getState()
    const { index, initial } = currentState.undoRedoHistory

    //do not increase index since there are two consecutive changes: size_id and size, see handleSizeChange
    if (payload.name === 'size_id' || payload.special === DO_NOT_SAVE_HISTORY) {
        return
    }

    const newForm: TemplateOrAlternativeTemplateType = selectFormValues(currentState, payload.form)
    const isDiff = !initial || (initial && isDifferentTemplateform(initial, newForm))

    if (!initial) {
        console.debug('no initial')
    } else if (!isDiff) {
        return
    }

    const ni = nextIndex(index) //next index
    const nni = nextIndex(ni)   //next next index

    let newBuffer: TemplateOrAlternativeTemplateType[]
    newBuffer = [...currentState.undoRedoHistory.buffer]
    newBuffer[ni] = newForm
    newBuffer[nni] = null

    const newState: UndoRedoHistory = {
        initial: initial ? initial : newBuffer[ni],
        buffer: newBuffer,
        index: ni,
    }

    yield put({
        type: PUSH_PRESENT_HISTORY,
        payload: newState,
    })
}

export function* watchTemplateFormChanged() {
    yield takeEvery(UPDATE_VALUE, handleTemplateFormChanged)
}
